/**
 * Product Accordion V2
 * Управление аккордеонами на странице продукта
 */

(function () {
if (window.ProductAccordionV2) {
  if (typeof window.initProductAccordions === 'function') {
    window.initProductAccordions();
  }
  return;
}

class ProductAccordionV2 {
  constructor(element) {
    this.element = element;
    this.title = this.element.querySelector('.product-text-info-accord-tittle');
    this.content = this.element.querySelector('.product-text-info-accord-tittle-text');
    this.icon = this.element.querySelector('.product-text-info-accord-icon');
    
    if (!this.title || !this.content) {
      return;
    }
    
    // Не показывать аккордеон, если внутри нет контента
    const hasContent = this.content && this.content.textContent.trim().length > 0;
    if (!hasContent) {
      this.element.style.display = 'none';
      return;
    }

    // Проверяем, должен ли аккордеон быть открыт по умолчанию
    const isOpenByDefault = this.element.dataset.openByDefault === 'true';
    if (isOpenByDefault) {
      this.element.classList.add('active');
    }
    
    this.init();
  }
  
  init() {
    this.title.addEventListener('click', () => this.toggle());
    
    // Поддержка клавиатуры
    this.title.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.toggle();
      }
    });
    
    // Делаем заголовок доступным для клавиатуры
    this.title.setAttribute('tabindex', '0');
    this.title.setAttribute('role', 'button');
    this.title.setAttribute('aria-expanded', this.element.classList.contains('active'));
  }
  
  toggle() {
    const isActive = this.element.classList.contains('active');
    
    if (isActive) {
      this.close();
    } else {
      this.open();
    }
  }
  
  open() {
    this.element.classList.add('active');
    this.title.setAttribute('aria-expanded', 'true');
  }
  
  close() {
    this.element.classList.remove('active');
    this.title.setAttribute('aria-expanded', 'false');
  }
}

// Инициализация при загрузке DOM
function initAccordions() {
  const accordions = document.querySelectorAll('.product-text-info-accord');
  accordions.forEach(accordion => {
    // Проверяем, не инициализирован ли уже
    if (!accordion.dataset.initialized) {
      new ProductAccordionV2(accordion);
      accordion.dataset.initialized = 'true';
    }
  });
}

window.ProductAccordionV2 = ProductAccordionV2;
window.initProductAccordions = initAccordions;

// Инициализация при загрузке DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAccordions);
} else {
  // DOM уже загружен
  initAccordions();
}

// Также инициализируем при динамическом обновлении контента (например, при смене варианта)
document.addEventListener('variant:change', () => {
  setTimeout(initAccordions, 100);
});
})();
